import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import * as _ from 'lodash';
import { ContentCard, Spinner } from 'components';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';
import * as styles from './ContentCardWrap.scss';

function ContentCardWrap(props) {
  var data = props.data,
      _handlePostCardClick = props.handlePostCardClick,
      handleScroll = props.handleScroll,
      hasMore = props.hasMore,
      loading = props.loading,
      loadMore = props.loadMore,
      isBucketPage = props.isBucketPage,
      categoryName = props.categoryName,
      bucketDetailHeight = props.bucketDetailHeight,
      queueControlArea = props.queueControlArea,
      queueRowHeight = props.queueRowHeight,
      starControl = props.starControl;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrap,
    onScroll: _.throttle(handleScroll, 300),
    style: {
      height: "calc(100% - ".concat(!isBucketPage ? 74 + parseInt(queueRowHeight || 16, 10) : queueRowHeight ? 74 + parseInt(bucketDetailHeight, 10) : 90 + parseInt(bucketDetailHeight, 10), "px)")
    }
  }, isBucketPage && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    style: queueControlArea ? {
      color: '#616161',
      fontSize: 25,
      paddingBottom: 8,
      margin: 0
    } : {
      color: '#616161',
      fontSize: 25,
      paddingBottom: 24,
      margin: 0
    }
  }, categoryName, " ", /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 8
    }
  }, starControl)), queueControlArea), /*#__PURE__*/React.createElement(InfiniteScroll, {
    loadMore: loadMore,
    hasMore: !loading && hasMore,
    initialLoad: false,
    useWindow: false,
    threshold: 700,
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-evenly'
    }
  }, data.map(function (d, index) {
    return /*#__PURE__*/React.createElement(ContentCard, _extends({
      key: "contentCard_".concat(index, "_").concat(d.id),
      metadata: d.metadata,
      handlePostCardClick: function handlePostCardClick() {
        _handlePostCardClick(d);
      }
    }, function () {
      var files = d.S3Files;

      if (files && files.length > 0) {
        var _files = _slicedToArray(files, 1),
            imageFile = _files[0];

        if (imageFile.Alternates && imageFile.Alternates.length > 0) {
          var targetSize = imageFile.Alternates.find(function (a) {
            return a.sizeKey === 'square-xlarge';
          });

          if (targetSize) {
            return {
              image: targetSize.fullyQualifiedUrl,
              dominantImageColor: targetSize.dominantColor
            };
          }
        }

        return {
          image: imageFile.fullyQualifiedUrl,
          dominantImageColor: imageFile.dominantColor
        };
      }
    }(), {
      message: d.message ? d.message : null,
      title: d.title ? d.title : null,
      linkUrl: d.linkUrl
    }));
  }), loading && /*#__PURE__*/React.createElement("div", {
    style: {
      flex: '0 0 100%',
      height: 100,
      maxWidth: '100%',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Spinner, {
    center: true
  }))));
}

ContentCardWrap.defaultProps = {
  handlePostCardClick: function handlePostCardClick() {
    console.log('no handler for handlePostCardClick() in ContentCard');
  },
  hasMore: true,
  data: [],
  handleScroll: function handleScroll() {
    console.log('no onScroll handler');
  },
  loading: false,
  loadMore: function loadMore() {
    console.log('no load more handler');
  },
  isBucketPage: false,
  categoryName: '',
  queueRowHeight: null
};
export default ContentCardWrap;